import { NOTIFICATION_INDICATOR } from 'components/notifications/utils/constants';
import { orderBy } from 'lodash';
import { format } from 'date-fns/format';
import { USER_ROLES } from 'services/user/constants';
import {
  ORDER_STATUS_CAL_APPROVER_DEFAULT_FILTERS,
  ORDER_STATUS_CAL_SUBMITTER_DEFAULT_FILTERS
} from '../constants';

export const getFormattedDate = (dateToFormat: string | Date) => {
  const date = new Date(dateToFormat);
  return format(date, 'MM/dd/yyyy');
};

export const getRedirectionLink = (
  dynamicLinks,
  orderId,
  orderNumber,
  orderQuoteDetailLink
) => {
  if (orderQuoteDetailLink?.includes('PendingOrderDetails')) {
    return dynamicLinks.PENDING_ORDER_DETAILS.getUrl({ orderId });
  } else if (orderQuoteDetailLink?.includes('AjaxLogonForm')) {
    const isOderIdExistInUrl = orderQuoteDetailLink
      ?.split('orderId=')
      ?.pop()
      ?.split('&')
      ?.shift();
    return dynamicLinks.ORDER_DETAIL.getUrl({
      orderId: isOderIdExistInUrl ?? orderId,
      dbsOrderId:
        orderNumber ||
        orderQuoteDetailLink?.split('dbsOrderId=')?.pop()?.split('&')?.[0]
    });
  }
  return orderQuoteDetailLink;
};

export const removeFullStop = (translation_text) => {
  if (translation_text.endsWith('.')) {
    return translation_text.slice(0, -1);
  } else {
    return translation_text;
  }
};

export const sortNotifications = (notifications) =>
  orderBy(
    notifications,
    [
      'isRead',
      (notification) =>
        !notification?.isRead &&
        !!NOTIFICATION_INDICATOR[notification?.orderStatus],
      (notification) => new Date(notification?.formattedDate)
    ],
    ['asc', 'desc', 'desc']
  );

export const isTodayDate = (expireDate: string) => {
  const today = new Date();
  return getFormattedDate(today) === getFormattedDate(expireDate);
};

export const findCalRolesFilters = (calRoles: string[]) => {
  if (
    calRoles.includes(USER_ROLES.APPROVER) ||
    calRoles.includes(USER_ROLES.ADMIN)
  ) {
    return ORDER_STATUS_CAL_APPROVER_DEFAULT_FILTERS;
  } else if (calRoles.includes(USER_ROLES.SUBMITTER)) {
    return ORDER_STATUS_CAL_SUBMITTER_DEFAULT_FILTERS;
  }
  return [];
};
